const Backbone = require('backbone');
const ProductView = require('app/views/store/pages/products/show.page').default;
const FinishesView = require('app/views/store/pages/products/finishes');
require('bootstrap');

module.exports = Backbone.View.extend({
	initialize: function() {
		this.childViews.product = new ProductView({
			containerEl: `${this._isMobile() ? '.js-finish-restriction' : '.js-finish-list .js-finish-restriction'}`
		});
		this.listenTo(Backbone, 'finish:hover', this._updateFinishInfo.bind(this));
		this.listenTo(Backbone, 'PLAfinish:selected', this._updateFinishInfo.bind(this));
		this.viewType = 'grid';
		this.templateType = window.BCOM.device.isMobile ? 'mobile' : 'global';
		this.$popoverButton = $('.js-finish-pla-popover');
		this.isPopoverVisible = false;
		this.fullProdPageUrl = $('.js-full-product-page').data('location');
		this.listenTo(Backbone, 'finish:clicked', this._getMoreLikeThis);
		if (this.$popoverButton.length) {
			this.listenTo(Backbone, 'body:click', this._handleBodyClick.bind(this));
			this.$popoverButton
				.popover({
					html: true,
					display: 'block',
					placement: 'left',
					trigger: 'manual',
					content: function() {
						return $('.js-finish-list').html();
					}
				})
				.on('show.bs.popover', this._togglePopoverState.bind(this))
				.on('hide.bs.popover', this._togglePopoverState.bind(this))
				.on('click', this._initFinishPopover.bind(this));
		}

		// pla page specific events
		$('.js-product-image-link').on('click', this._handleProductImageLinkClick.bind(this));
		$('.js-review-trigger, .js-rating-link').on('click', this._handleWriteReviewClick.bind(this));
		$('.js-full-product-page').on('click', this._trackFullPageClick.bind(this));
		$('.js-add-to-cart').on('click', this._trackPlaConfigureAddToCartClick.bind(this));
	},

	_isMobile() {
		return window.BCOM.device.isMobile;
	},

	/**
	 * Keeping track of popover visiblity
	 * @param  {Object} e Event object passed from bootstrap popover show/hide events
	 */
	_togglePopoverState: function(e) {
		this.isPopoverVisible = e.type === 'show';
	},

	/**
	 * Pre-existing finish/swatch html loses all it's bindings when yoinked into the popover. Need to re-init.
	 */
	_initFinishPopover: function(event) {
		event.preventDefault();
		this.$popoverButton.popover('toggle');
		if (this.isPopoverVisible) {
			// warning: this wil create backbone zombie views
			this.childViews.product.childViews.purchase.childViews.finishes = new FinishesView({
				pageView: this.childViews.product,
				collection: this.childViews.product.model.finishes,
				model: this.childViews.product.model
			});
		}
	},
	_handleBodyClick: function(e) {
		if (
			this.isPopoverVisible &&
			!$.contains(this.$popoverButton.next('.popover')[0], e.target) &&
			!$(e.target).is(this.$popoverButton) &&
			!$.contains(this.$popoverButton[0], e.target)
		) {
			if (!$(e.target).is('.js-finish-popover')) {
				e.preventDefault();
			}
			this.$popoverButton.popover('hide');
		}
	},
	_updateFinishInfo: function(model) {
		$('.js-pla-image').prop('src', model.image100x100);
		$('.js-pla-stock').text(model.stockMessage);
		$('.js-pla-link').attr('href', model.productLink);
	},

	_trackFullPageClick: function(e) {
		e.preventDefault();
		Backbone.trigger('omniture:plaPageToFullProductPage');
		window.location.assign(window.BCOM.util.updateURLParameters(this.fullProdPageUrl, 'uid', window.dataLayer.selectedFinishId));
	},
	_trackPlaConfigureAddToCartClick: function(e) {
		e.preventDefault();
		Backbone.trigger('omniture:plaConfigureAddToCart');
	},
	/**
	 * Not going to allow write a review on pla page. Hijacking the click event.
	 * Write a Review link text has been changed to 'Read Reviews' and will redirect to full full product page with reviews tab trigger.
	 */
	_handleWriteReviewClick: function(event) {
		event.stopPropagation();
		event.preventDefault();
		window.location.assign(
			`${window.BCOM.util.updateURLParameters(this.fullProdPageUrl, 'uid', window.dataLayer.selectedFinishId)}#reviews`
		);
	},

	_handleProductImageLinkClick: function(e) {
		Backbone.trigger('omniture:clicktracking', 'media gallery:opened');
		window.location.assign($(e.currentTarget).attr('href'));
	}
});
